// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 底部导航优化 */
.bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 64px;
  background: rgba(255,255,255,.86);
  border-top: 1px solid var(--color-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  padding: 0 2px;
  backdrop-filter: saturate(160%) blur(16px);
  box-shadow: 0 -4px 16px -6px rgba(0,0,0,.15);
}

.nav-item {
  flex: 1 1;
  text-align: center;
  color: var(--color-text-sec);
  text-decoration: none;
  font-size: .7rem;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  transition: var(--transition-fast);
  letter-spacing: .5px;
  min-height: 64px;
  min-width: 44px; /* 确保最小触摸区域 */
  padding: 8px 4px; /* 增加内边距 */
}

.nav-icon {
  width: 24px;
  height: 24px;
  transition: var(--transition-fast);
  filter: drop-shadow(0 2px 4px rgba(0,0,0,.1));
  min-width: 24px; /* 确保图标最小尺寸 */
  min-height: 24px;
}

.nav-item::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(140deg,rgba(99,102,241,.12),rgba(99,102,241,0));
  opacity: 0;
  transition: var(--transition-fast);
}

.nav-item:hover { color: var(--color-text); }
.nav-item:hover .nav-icon { transform: translateY(-2px); filter: drop-shadow(0 4px 8px rgba(0,0,0,.2)); }
.nav-item:hover::after { opacity: 1; }
.nav-item.active { color: var(--color-primary); font-weight: 700; }
.nav-item.active .nav-icon { transform: translateY(-4px) scale(1.08); filter: drop-shadow(0 4px 8px rgba(99,102,241,.3)); }
.nav-item.active::after { opacity: 1; box-shadow: inset 0 0 0 1px rgba(99,102,241,.25); }

/* 移动端响应式优化 */
@media (max-width: 480px) {
  .bottom-nav { height: 60px; }
  .nav-item {
    min-height: 60px;
    font-size: .65rem;
    min-width: 48px; /* 增加小屏幕触摸区域 */
    padding: 6px 2px;
  }
  .nav-icon {
    width: 22px;
    height: 22px;
    min-width: 22px;
    min-height: 22px;
  }
}

@media (max-width: 360px) {
  .nav-item {
    min-width: 44px; /* 保持最小触摸区域 */
    font-size: .55rem; /* 四个导航项时稍微减小字体 */
    gap: 2px; /* 减少图标和文字间距 */
  }
  .nav-icon {
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
  }

  /* 四个导航项时的特殊优化 */
  .bottom-nav {
    padding: 0 1px; /* 减少左右内边距 */
  }
}

/* 极小屏幕优化 (≤320px) */
@media (max-width: 320px) {
  .nav-item {
    font-size: .5rem;
    min-width: 40px;
    gap: 1px;
  }

  .nav-icon {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
  }

  .bottom-nav {
    padding: 0;
  }
}

/* 触摸设备优化 */
@media (pointer: coarse) {
  .nav-item {
    min-height: 56px;
    min-width: 56px;
    padding: 8px 6px;
  }

  .nav-icon {
    width: 26px;
    height: 26px;
    min-width: 26px;
    min-height: 26px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/BottomNav.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,iCAAiC;EACjC,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe,EAAE,aAAa;EAC9B,gBAAgB,EAAE,UAAU;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,6CAA6C;EAC7C,eAAe,EAAE,aAAa;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2EAA2E;EAC3E,UAAU;EACV,kCAAkC;AACpC;;AAEA,kBAAkB,wBAAwB,EAAE;AAC5C,4BAA4B,2BAA2B,EAAE,6CAA6C,EAAE;AACxG,yBAAyB,UAAU,EAAE;AACrC,mBAAmB,2BAA2B,EAAE,gBAAgB,EAAE;AAClE,6BAA6B,uCAAuC,EAAE,kDAAkD,EAAE;AAC1H,0BAA0B,UAAU,EAAE,gDAAgD,EAAE;;AAExF,aAAa;AACb;EACE,cAAc,YAAY,EAAE;EAC5B;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe,EAAE,cAAc;IAC/B,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe,EAAE,aAAa;IAC9B,iBAAiB,EAAE,iBAAiB;IACpC,QAAQ,EAAE,cAAc;EAC1B;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,cAAc,EAAE,YAAY;EAC9B;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* 底部导航优化 */\n.bottom-nav {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 64px;\n  background: rgba(255,255,255,.86);\n  border-top: 1px solid var(--color-border);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 1000;\n  padding: 0 2px;\n  backdrop-filter: saturate(160%) blur(16px);\n  box-shadow: 0 -4px 16px -6px rgba(0,0,0,.15);\n}\n\n.nav-item {\n  flex: 1;\n  text-align: center;\n  color: var(--color-text-sec);\n  text-decoration: none;\n  font-size: .7rem;\n  font-weight: 600;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  position: relative;\n  transition: var(--transition-fast);\n  letter-spacing: .5px;\n  min-height: 64px;\n  min-width: 44px; /* 确保最小触摸区域 */\n  padding: 8px 4px; /* 增加内边距 */\n}\n\n.nav-icon {\n  width: 24px;\n  height: 24px;\n  transition: var(--transition-fast);\n  filter: drop-shadow(0 2px 4px rgba(0,0,0,.1));\n  min-width: 24px; /* 确保图标最小尺寸 */\n  min-height: 24px;\n}\n\n.nav-item::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(140deg,rgba(99,102,241,.12),rgba(99,102,241,0));\n  opacity: 0;\n  transition: var(--transition-fast);\n}\n\n.nav-item:hover { color: var(--color-text); }\n.nav-item:hover .nav-icon { transform: translateY(-2px); filter: drop-shadow(0 4px 8px rgba(0,0,0,.2)); }\n.nav-item:hover::after { opacity: 1; }\n.nav-item.active { color: var(--color-primary); font-weight: 700; }\n.nav-item.active .nav-icon { transform: translateY(-4px) scale(1.08); filter: drop-shadow(0 4px 8px rgba(99,102,241,.3)); }\n.nav-item.active::after { opacity: 1; box-shadow: inset 0 0 0 1px rgba(99,102,241,.25); }\n\n/* 移动端响应式优化 */\n@media (max-width: 480px) {\n  .bottom-nav { height: 60px; }\n  .nav-item {\n    min-height: 60px;\n    font-size: .65rem;\n    min-width: 48px; /* 增加小屏幕触摸区域 */\n    padding: 6px 2px;\n  }\n  .nav-icon {\n    width: 22px;\n    height: 22px;\n    min-width: 22px;\n    min-height: 22px;\n  }\n}\n\n@media (max-width: 360px) {\n  .nav-item {\n    min-width: 44px; /* 保持最小触摸区域 */\n    font-size: .55rem; /* 四个导航项时稍微减小字体 */\n    gap: 2px; /* 减少图标和文字间距 */\n  }\n  .nav-icon {\n    width: 18px;\n    height: 18px;\n    min-width: 18px;\n    min-height: 18px;\n  }\n\n  /* 四个导航项时的特殊优化 */\n  .bottom-nav {\n    padding: 0 1px; /* 减少左右内边距 */\n  }\n}\n\n/* 极小屏幕优化 (≤320px) */\n@media (max-width: 320px) {\n  .nav-item {\n    font-size: .5rem;\n    min-width: 40px;\n    gap: 1px;\n  }\n\n  .nav-icon {\n    width: 16px;\n    height: 16px;\n    min-width: 16px;\n    min-height: 16px;\n  }\n\n  .bottom-nav {\n    padding: 0;\n  }\n}\n\n/* 触摸设备优化 */\n@media (pointer: coarse) {\n  .nav-item {\n    min-height: 56px;\n    min-width: 56px;\n    padding: 8px 6px;\n  }\n\n  .nav-icon {\n    width: 26px;\n    height: 26px;\n    min-width: 26px;\n    min-height: 26px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
